import ServerSettings from "../../../gd/settings/server-settings/server-settings"
import {BackGround} from "../../../gd-app/panels/preferences-panel/settings-background/settings-background"
import {ColumnSettingsConfig, SystemColumnType} from "../../../gd-modules/manager/columns/types"
import {GroupingType} from "../../../gd/manager/group-by/@types"

// const debug = "UserSettingsViewsMyTime"
const debug = false

export default class UserSettingsViewsMyTime extends ServerSettings {

    public displayPlannedTasks      : boolean
    public dailyDisplayViewedTasks  : boolean // Recent tasks
    public showProject              : boolean
    public showProjectFullPath      : boolean
    public background               : BackGround

    public columns                  : ColumnSettingsConfig[]
    public grouping                 : any

    public pinnedTasks              : ID[]

    constructor(config: any) {

        const fieldsConfig = {

            'displayPlannedTasks': {
                type            : 'value',
                defaultValue    : true,
            },

            'dailyDisplayViewedTasks': {
                type            : 'value',
                defaultValue    : true,
            },

            'showProject': {
                type            : 'value',
                defaultValue    : false,
            },

            'showProjectFullPath': {
                type            : 'value',
                defaultValue    : false,
            },


            'columns': {
                type            : 'value',
                defaultValue    : [
                    { id: SystemColumnType.TITLE },
                    { id: SystemColumnType.COMMENTS },
                    { id: SystemColumnType.TIME_REPORTED },
                ],
            },

            'grouping': {
                type            : 'value',
                defaultValue    : {
                    mode    : GroupingType.CUSTOM,
                    fields  : [{ fieldId: 'activityType' }],
                },
            },

            'dailyDisplayComment': {
                type            : 'value',
                defaultValue    : true,
            },

            'dailyDisplayStartEnd': {
                type            : 'value',
                defaultValue    : true,
            },

            'displayIsBillable': {
                type            : 'value',
                defaultValue    : true,
            },

            'background': {
                type            : 'value',
                defaultValue    : BackGround.WHITE,
            },

            'pinnedTasks': {
                type            : 'value',
                defaultValue    : [],
            },

        }

        super(config, fieldsConfig);


        this.displayPlannedTasks        = this.initValue('displayPlannedTasks')
        this.dailyDisplayViewedTasks    = this.initValue('dailyDisplayViewedTasks')
        this.showProject                = this.initValue('showProject')
        this.showProjectFullPath        = this.initValue('showProjectFullPath')
        this.background                 = this.initValue('background')

        this.columns                    = this.initValue('columns')
        this.grouping                   = this.initValue('grouping')

        this.pinnedTasks                = this.initValue('pinnedTasks')
    }


    toJson() {
        const result = {};

        this.valueToJson(result, 'displayPlannedTasks')
        this.valueToJson(result, 'dailyDisplayViewedTasks')
        this.valueToJson(result, 'showProject')
        this.valueToJson(result, 'showProjectFullPath')
        this.valueToJson(result, 'background')

        this.valueToJson(result, 'columns')
        this.valueToJson(result, 'grouping')

        this.valueToJson(result, 'pinnedTasks')

        debug && console.log(debug, 'toJson', result, this)

        return result;
    }
}
